/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Save_CancelInputs */



/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Video_Export_Export_Preset_Save_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_save_cancel = /** @type {((inputs?: Video_Export_Export_Preset_Save_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Save_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stornieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancellare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отмена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("取消")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャンセル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रद्द करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancelar")
	return /** @type {LocalizedString} */ ("Cancel")
});